import React, { useEffect, useState } from "react";
import { Badge, Avatar, Popover } from "antd";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Profile from "../medium/Profile";
import { profileCharacters } from "../../utils/helper";
import NotificationMiniView from "../medium/NotificationMiniView";
import { getAllNotifications } from "../../redux/actions/notificationAction";
import { modalState } from "../../redux/actions/modalAction";
import MenuIcon from "@material-ui/icons/Menu";
import BackIcon from "@material-ui/icons/KeyboardBackspaceOutlined";
import MUIAvatar from "@material-ui/core/Avatar";
import MobileMenu from "../Header/MobileMenu";
import MobileProfileMenu from "../Header/MobileProfileMenu";
import MobileNotifPopup from "../Header/MobileNotifPopup";
import { useAuthStore } from "../../store/AuthStore";
import BellIcon from "../../assets/card_icons/BellIcon";
import ChatIcon from "../../assets/card_icons/ChatIcon";
import DoveMedLogo from "../../assets/images/icons/new-dovemed-logo.svg";
import { useQuery } from "@tanstack/react-query";
import { getUnreadMessagesAPI } from "../../api/Messages";

const Header = ({ notifications, getAllNotifications, modalState }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { isLoggedIn, hasBlog, isPhysician, userData, isVerified, mainBlogId } =
    useAuthStore();

  //MOBILE MENU STATES
  const [showMenu, toggleMenu] = useState(false);
  const [showProfile, toggleProfile] = useState(false);
  const [showNotifPopup, setShowNotifPopup] = useState(false);

  const [showProfileDesktop, setShowProfileDesktop] = useState(false);
  const [unreadNotifications, setUnreadNotifications] = useState(false);

  const { data: chatUnreadCount } = useQuery({
    queryKey: ["GetUnreadChats", userData?.id],
    queryFn: () => getUnreadMessagesAPI(userData?.id),
    select: ({ data }) => data.data.count,
    enabled: !!userData?.id,
  });

  // TODO: WRITE GET NOTIFICATIONS API AND REFORMAT TO REACT QUERY
  useEffect(() => {
    getAllNotifications(5, 1);
  }, []);

  // TODO: MODIFY AND REFORMAT TO WORK WITH REACT QUERY
  useEffect(() => {
    if (notifications.length > 0) {
      setUnreadNotifications(notifications.some((value) => !value.isRead));
    }
  }, [notifications]);

  const toggleProfDesktop = () => {
    setShowProfileDesktop(false);
  };

  //Notif Popover
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleGoToHome = () => {
    sessionStorage.clear();
    sessionStorage.setItem("HomePageNumber", 1);
    sessionStorage.setItem("HomePageFilter", "recent");

    if (pathname === "/") {
      window.location.reload();
    } else {
      history.replace("/");
    }
    toggleMenu(false);
  };

  const handleGoToSearch = () => {
    sessionStorage.clear();

    history.push("/search/1/posts");
    toggleMenu(false);
  };

  return (
    <header>
      <div className="header-container">
        {/* Link to DoveMed */}
        <div className="route-main-home">
          <div className="cen">
            <a href="/">
              <BackIcon fontSize="small" /> GO TO DOVEMED
            </a>
            {!isVerified && <p>Please Verify your Email</p>}
            <div></div>
          </div>
        </div>

        {/* Header */}
        <nav className="container-fluid max-w-screen-xl nav-wrapper">
          {/* Mobile */}
          <div className="nav-mobile">
            <button
              onClick={() => {
                toggleMenu(!showMenu);
              }}
              className="mr-2 flex items-center md:hidden rounded-lgtext-teal-200 border-teal-400 hover:text-white hover:border-white text-white"
            >
              <MenuIcon />
            </button>

            <div onClick={handleGoToHome} className="nav-logo">
              <img
                style={{
                  height: "100%",
                  width: "100%",
                }}
                src={DoveMedLogo}
                alt="Logo"
              />
            </div>

            <div className="nav-actions">
              {!isLoggedIn && (
                <p
                  className="login"
                  // onClick={() => modalState(true)}
                  onClick={() => {
                    window.location.href = `${process.env.REACT_APP_AUTH_SSO_URI}/dovemed-sso?next=${process.env.REACT_APP_AUTH_SSO_URI}/blogs`;
                  }}
                >
                  LOGIN
                </p>
              )}
              {isLoggedIn && (
                <Badge
                  dot={unreadNotifications}
                  onClick={() => setShowNotifPopup(!showNotifPopup)}
                >
                  <BellIcon />
                </Badge>
              )}
              {isLoggedIn && isPhysician && (
                <Badge
                  dot={chatUnreadCount}
                  onClick={() => {
                    history.push(`/messages`);
                    toggleMenu(false);
                  }}
                >
                  <ChatIcon />
                </Badge>
              )}
              {isLoggedIn && (
                <MUIAvatar
                  size={28}
                  alt={userData?.firstName}
                  src={userData?.profileImage}
                  onClick={() => toggleProfile(!showProfile)}
                >
                  {profileCharacters(userData?.firstName, userData?.lastName)}
                </MUIAvatar>
              )}
            </div>
          </div>

          {/* Desktop */}
          <div className="nav-desktop">
            <div onClick={handleGoToHome}>
              <img
                style={{ height: "2.1rem", cursor: "pointer" }}
                src={DoveMedLogo}
                className="h-10"
                alt="DoveMed Logo"
              />
            </div>

            <div className="nav-actions">
              <p className="link" onClick={handleGoToHome}>
                HOME
              </p>
              <p className="link" onClick={handleGoToSearch}>
                SEARCH
              </p>
              {isLoggedIn && isPhysician && hasBlog && (
                <p
                  className="link"
                  onClick={() => {
                    history.push(`/createPost/${mainBlogId}/post/new`);
                    toggleMenu(false);
                  }}
                >
                  CREATE POST
                </p>
              )}

              {/* Notification */}
              {isLoggedIn && (
                <Popover
                  trigger="click"
                  placement="bottomRight"
                  content={<NotificationMiniView hide={hide} />}
                  className="block md:inline-block cursor-pointer"
                  open={open}
                  onOpenChange={handleOpenChange}
                >
                  <Badge dot={unreadNotifications}>
                    <BellIcon />
                  </Badge>
                </Popover>
              )}

              {/* Chat */}
              {isLoggedIn && isPhysician && (
                <Badge
                  className="cursor-pointer"
                  dot={chatUnreadCount}
                  onClick={() => {
                    history.push(`/messages`);
                    toggleMenu(false);
                  }}
                >
                  <ChatIcon />
                </Badge>
              )}

              {!isLoggedIn && (
                <p
                  className="link"
                  // onClick={() => modalState(true)}
                  onClick={() => {
                    window.location.href = `${process.env.REACT_APP_AUTH_SSO_URI}/dovemed-sso?next=${process.env.REACT_APP_AUTH_SSO_URI}/blogs`;
                  }}
                >
                  LOGIN
                </p>
              )}
            </div>

            {isLoggedIn && (
              <Popover
                trigger="click"
                open={showProfileDesktop}
                onOpenChange={() => setShowProfileDesktop(!showProfileDesktop)}
                placement="bottomLeft"
                className="cursor-pointer"
                content={
                  <Profile
                    history={history}
                    toggleMenu={toggleMenu}
                    toggleProfile={toggleProfDesktop}
                  />
                }
              >
                <Avatar
                  size={38}
                  icon={profileCharacters(
                    userData?.firstName,
                    userData?.lastName
                  )}
                  src={userData?.profileImage}
                />
              </Popover>
            )}
          </div>
        </nav>

        {/* Mobile Popup Nav */}
        {showMenu && <MobileMenu toggleMenu={toggleMenu} />}
        {showProfile && <MobileProfileMenu toggleProfile={toggleProfile} />}
        {showNotifPopup && (
          <MobileNotifPopup setShowNotifPopup={setShowNotifPopup} />
        )}
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  notifications: state.notification.notifications,
});

export default connect(mapStateToProps, {
  getAllNotifications,
  modalState,
})(Header);
